/*
 * Avelore — vitrine: compra rápida no card, gaveta do atacado e barra fixa do produto.
 * A lógica pura fica no topo e é exportada para os testes (node:test);
 * a parte de DOM só roda no navegador, depois de constants.js, pubsub.js, global.js e product-form.js.
 * Toda alteração de carrinho passa por /cart/add, /cart/change ou /cart/update: o avelore-datalayer.js
 * mede add_to_cart/remove_from_cart pela diferença do carrinho, sem código de rastreamento aqui.
 */
(function (root) {
  'use strict';

  function normalizarCor(nome) {
    return String(nome == null ? '' : nome)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\./g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function limitarQuantidade(valor, maximo) {
    var n = parseInt(valor, 10);
    var q = isFinite(n) ? n : 1;
    if (q < 1) q = 1;
    if (typeof maximo === 'number' && isFinite(maximo) && maximo >= 1 && q > maximo) q = maximo;
    return q;
  }

  // Troca de cor de uma linha do carrinho: zera a linha e soma a quantidade na nova variante
  // (sem sobrescrever o que já existe dela). Formato de `updates` do /cart/update.js.
  function montarTrocaCor(itens, chaveLinha, novaVarianteId) {
    var lista = Array.isArray(itens) ? itens : [];
    var linha = null;
    for (var i = 0; i < lista.length; i++) if (lista[i].key === chaveLinha) linha = lista[i];
    if (!linha) return null;
    var alvo = String(novaVarianteId);
    if (String(linha.variant_id) === alvo) return null;
    var existente = 0;
    for (var j = 0; j < lista.length; j++) if (String(lista[j].variant_id) === alvo) existente += lista[j].quantity;
    var updates = {};
    updates[chaveLinha] = 0;
    updates[alvo] = existente + linha.quantity;
    return updates;
  }

  // A festa do atacado só acontece na virada de "inativo" para "ativo" (nunca na carga da página).
  function transicaoAtacado(anterior, atual) {
    return anterior === false && atual === true ? 'festa' : 'nada';
  }

  var api = {
    normalizarCor: normalizarCor,
    limitarQuantidade: limitarQuantidade,
    montarTrocaCor: montarTrocaCor,
    transicaoAtacado: transicaoAtacado,
  };

  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  root.AveloreLoja = api;

  // ---------------- DOM ----------------
  var TEXTO_ADICIONAR = 'Adicionar';
  var TEXTO_ESGOTADO = 'Esgotado';
  var TEXTO_ADICIONADO = '\u2713 Adicionado';
  var TEXTO_ERRO_TROCA = 'N\u00e3o foi poss\u00edvel trocar a cor agora. Tente de novo.';

  var reduzirMovimento = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function temPubSub() {
    return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  function acharVariante(lista, id) {
    for (var i = 0; i < lista.length; i++) if (String(lista[i].id) === String(id)) return lista[i];
    return null;
  }

  // ---------- card: <avelore-card-compra> ----------
  if (!customElements.get('avelore-card-compra')) {
    customElements.define('avelore-card-compra', class extends HTMLElement {
      connectedCallback() {
        if (!this.iniciado) {
          this.iniciado = true;
          this.inicializar();
        }
        this.assinar();
      }

      disconnectedCallback() {
        this.desassinar();
      }

      inicializar() {
        var self = this;
        var dados = this.querySelector('script[data-avelore-variantes]');
        try {
          this.variantes = dados ? JSON.parse(dados.textContent) : [];
        } catch (e) {
          this.variantes = [];
        }
        this.inputId = this.querySelector('input[name="id"]');
        this.inputQtd = this.querySelector('input[name="quantity"]');
        this.botao = this.querySelector('.avelore-card-compra__add');
        this.textoBotao = this.botao ? this.botao.querySelector('span') : null;
        this.legenda = this.querySelector('[data-avelore-legenda]');
        this.titulo = this.getAttribute('data-titulo') || '';
        var card = this.closest('.card-wrapper');
        var foto0 = card ? card.querySelector('.card__media img') : null;
        this.fotoOriginal = foto0 ? { src: foto0.getAttribute('src'), srcset: foto0.getAttribute('srcset') } : null;
        this.addEventListener('change', this.aoMudar.bind(this));
        this.addEventListener('click', this.aoClicar.bind(this));
        var form = this.querySelector('form');
        if (form) form.addEventListener('submit', function () { self.pendente = true; }, true);
        this.atualizarLimite();
      }

      // "✓ Adicionado" só depois da resposta de sucesso da Shopify para a variante deste card.
      assinar() {
        if (this.cancelar || !temPubSub()) return;
        var self = this;
        var daqui = function (evento) {
          return evento && evento.source === 'product-form' && self.inputId && String(evento.productVariantId) === String(self.inputId.value);
        };
        this.cancelar = [
          subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
            if (!self.pendente || !daqui(evento)) return;
            self.pendente = false;
            self.mostrarAdicionado();
          }),
          subscribe(PUB_SUB_EVENTS.cartError, function (evento) {
            if (daqui(evento)) self.pendente = false;
          }),
        ];
      }

      desassinar() {
        if (!this.cancelar) return;
        this.cancelar.forEach(function (f) { if (typeof f === 'function') f(); });
        this.cancelar = null;
      }

      varianteAtual() {
        return this.inputId ? acharVariante(this.variantes, this.inputId.value) : null;
      }

      maximo() {
        var v = this.varianteAtual();
        return v && typeof v.estoque === 'number' ? v.estoque : null;
      }

      atualizarLimite() {
        if (!this.inputQtd) return;
        var max = this.maximo();
        if (max) this.inputQtd.max = String(max);
        else this.inputQtd.removeAttribute('max');
        this.inputQtd.value = String(limitarQuantidade(this.inputQtd.value, max));
      }

      aoMudar(evento) {
        var alvo = evento.target;
        if (alvo.matches && alvo.matches('input[data-avelore-cor]')) this.selecionar(alvo.value);
        else if (alvo === this.inputQtd) this.atualizarLimite();
      }

      aoClicar(evento) {
        var botao = evento.target.closest ? evento.target.closest('button') : null;
        if (!botao || !this.contains(botao)) return;
        if (botao.hasAttribute('data-avelore-menos') || botao.hasAttribute('data-avelore-mais-qtd')) {
          evento.preventDefault();
          if (!this.inputQtd) return;
          var passo = botao.hasAttribute('data-avelore-menos') ? -1 : 1;
          var atual = parseInt(this.inputQtd.value, 10) || 1;
          this.inputQtd.value = String(limitarQuantidade(atual + passo, this.maximo()));
          return;
        }
        if (botao.hasAttribute('data-avelore-mais')) {
          evento.preventDefault();
          var lista = this.querySelector('.avelore-cores');
          if (lista) lista.classList.add('is-expandida');
          botao.hidden = true;
        }
      }

      selecionar(id) {
        var v = acharVariante(this.variantes, id);
        if (!v) return;
        if (this.inputId) this.inputId.value = String(v.id);
        if (this.legenda) this.legenda.textContent = v.valor;
        if (this.botao) {
          this.botao.disabled = !v.disponivel;
          if (this.titulo) this.botao.setAttribute('aria-label', v.disponivel ? 'Adicionar ' + this.titulo + ' ao carrinho' : this.titulo + ' ' + TEXTO_ESGOTADO.toLowerCase());
          if (this.textoBotao && !this.botao.classList.contains('is-adicionado')) {
            this.textoBotao.textContent = v.disponivel ? TEXTO_ADICIONAR : TEXTO_ESGOTADO;
          }
        }
        var pf = this.querySelector('product-form');
        if (pf && typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage();
        this.atualizarLimite();
        this.trocarFoto(v);
      }

      // Foto da cor escolhida no card; a 2ª foto (do hover) sai para não mostrar outra cor.
      // Cor sem foto própria depois de uma troca: volta a foto original do produto.
      trocarFoto(v) {
        var card = this.closest('.card-wrapper');
        if (!card) return;
        var foto = v.img && v.img.src ? v.img : null;
        if (!foto) {
          if (!card.classList.contains('avelore-foto-trocada') || !this.fotoOriginal) return;
          foto = this.fotoOriginal;
        }
        var imagens = card.querySelectorAll('.card__media img');
        if (!imagens.length) return;
        for (var i = 1; i < imagens.length; i++) imagens[i].remove();
        var img = imagens[0];
        if (foto.srcset) img.setAttribute('srcset', foto.srcset);
        else img.removeAttribute('srcset');
        img.setAttribute('src', foto.src);
        card.classList.add('avelore-foto-trocada');
      }

      mostrarAdicionado() {
        if (!this.botao || !this.textoBotao) return;
        var self = this;
        this.botao.classList.add('is-adicionado');
        this.textoBotao.textContent = TEXTO_ADICIONADO;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          self.botao.classList.remove('is-adicionado');
          var v = self.varianteAtual();
          self.textoBotao.textContent = !v || v.disponivel ? TEXTO_ADICIONAR : TEXTO_ESGOTADO;
        }, 1500);
        if (this.inputQtd) this.inputQtd.value = '1';
      }
    });
  }

  // ---------- gaveta: barra animada e festa do atacado ----------
  // Ao adicionar pelo card, o tema redesenha a gaveta duas vezes (renderContents e, logo depois,
  // onCartUpdate troca o cart-drawer-items). Por isso a festa tem prazo (festaAte): a barra nova que
  // chega nesse prazo recebe o pulso de novo, e os confetes ficam numa camada do .drawer__inner,
  // que o onCartUpdate não substitui.
  var DURACAO_FESTA = 2400;
  var DURACAO_BARRA = 600;
  var festaAte = 0;

  function pulsar(el) {
    el.classList.remove('avelore-atacado--festa');
    void el.offsetWidth;
    el.classList.add('avelore-atacado--festa');
    setTimeout(function () { el.classList.remove('avelore-atacado--festa'); }, Math.max(0, festaAte - Date.now()));
  }

  function soltarConfetes(el) {
    if (reduzirMovimento) return;
    var inner = el.closest('.drawer__inner') || el.parentElement;
    if (!inner) return;
    var camada = document.createElement('div');
    camada.className = 'avelore-confetes';
    camada.setAttribute('aria-hidden', 'true');
    camada.style.top = Math.max(0, Math.round(el.getBoundingClientRect().top - inner.getBoundingClientRect().top)) + 'px';
    var cores = ['#C49A6C', '#E8C99B', '#FFFFFF', '#8B5E3C'];
    for (var i = 0; i < 16; i++) {
      var c = document.createElement('span');
      c.className = 'avelore-confete';
      c.style.left = (4 + Math.random() * 92) + '%';
      c.style.background = cores[i % cores.length];
      c.style.animationDelay = (Math.random() * 0.35).toFixed(2) + 's';
      c.style.setProperty('--giro', Math.round(Math.random() * 720 - 360) + 'deg');
      camada.appendChild(c);
    }
    inner.appendChild(camada);
    setTimeout(function () { camada.remove(); }, DURACAO_FESTA);
  }

  function festejar(el) {
    festaAte = Date.now() + DURACAO_FESTA;
    pulsar(el);
    soltarConfetes(el);
  }

  // Anima a barra de progresso; se a barra for substituída no meio da animação, a nova continua
  // de onde a anterior estava (em vez de pular direto para o fim).
  function animarBarra(barra, anim, novo) {
    var agora = Date.now();
    var de = null;
    var duracao = DURACAO_BARRA;
    if (anim.para !== novo) {
      de = anim.atual;
      anim.de = anim.atual;
      anim.para = novo;
      anim.inicio = agora;
    } else if (agora - anim.inicio < DURACAO_BARRA) {
      var f = (agora - anim.inicio) / DURACAO_BARRA;
      de = anim.de + (anim.para - anim.de) * f;
      duracao = DURACAO_BARRA - (agora - anim.inicio);
    }
    anim.atual = novo;
    if (de === null || reduzirMovimento) return;
    barra.style.transitionDuration = '0s';
    barra.style.width = de + '%';
    void barra.offsetWidth;
    barra.style.transitionDuration = duracao + 'ms';
    barra.style.width = novo + '%';
  }

  // A gaveta é redesenhada pelo tema a cada mudança; o observador compara o estado anterior
  // da barra com o novo para animar o progresso e festejar só na virada para "ativo".
  function iniciarGaveta() {
    var gaveta = document.querySelector('cart-drawer');
    if (!gaveta) return;
    var inicial = gaveta.querySelector('[data-avelore-atacado]');
    var anterior = inicial ? inicial.getAttribute('data-ativo') === 'true' : false;
    var p0 = inicial ? Number(inicial.getAttribute('data-progresso')) || 0 : 0;
    var anim = { de: p0, para: p0, atual: p0, inicio: 0 };
    var ultimaBarra = inicial;
    var agendado = false;
    new MutationObserver(function () {
      if (agendado) return;
      agendado = true;
      Promise.resolve().then(function () {
        agendado = false;
        var el = gaveta.querySelector('[data-avelore-atacado]');
        if (el === ultimaBarra) return;
        ultimaBarra = el;
        var atual = el ? el.getAttribute('data-ativo') === 'true' : false;
        if (el) {
          var barra = el.querySelector('.avelore-atacado__barra');
          var novo = Number(el.getAttribute('data-progresso')) || 0;
          if (barra) animarBarra(barra, anim, novo);
          else anim.atual = novo;
        } else {
          anim.atual = 0;
          anim.para = 0;
        }
        if (el && transicaoAtacado(anterior, atual) === 'festa') festejar(el);
        else if (el && atual && Date.now() < festaAte) pulsar(el);
        anterior = atual;
      });
    }).observe(gaveta, { childList: true, subtree: true });
  }

  // ---------- gaveta: troca de cor ----------
  // Uma troca por vez e a lista da gaveta travada durante a troca (como o tema faz no + e −):
  // a troca apaga uma linha e cria outra, e um + / − no meio usaria o índice de linha errado.
  var trocando = false;

  function travarLista(travar) {
    var lista = document.getElementById('CartDrawer-CartItems');
    if (lista) lista.classList.toggle('cart__items--disabled', travar);
  }

  function focarLinha(varianteId) {
    var gaveta = document.querySelector('cart-drawer');
    if (!gaveta || typeof trapFocus !== 'function') return;
    var bolinha = gaveta.querySelector('[data-avelore-troca] [data-variante="' + varianteId + '"]');
    var linha = bolinha ? bolinha.closest('.cart-item') : null;
    var alvo = (linha && linha.querySelector('.cart-item__name')) || gaveta.querySelector('.cart-item__name');
    if (alvo) trapFocus(gaveta, alvo);
  }

  function avisarNaGaveta(texto) {
    var alvo = document.getElementById('CartDrawer-CartErrors');
    if (alvo) alvo.textContent = texto;
  }

  function trocarCor(caixa, chaveLinha, novaVariante) {
    var itensEl = document.querySelector('cart-drawer-items');
    if (trocando || !itensEl || typeof itensEl.getSectionsToRender !== 'function') return;
    trocando = true;
    caixa.classList.add('is-carregando');
    travarLista(true);
    avisarNaGaveta('');
    var pedido = null;
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        var updates = montarTrocaCor(carrinho.items, chaveLinha, novaVariante);
        if (!updates) return null;
        pedido = updates[String(novaVariante)];
        var secoes = itensEl.getSectionsToRender();
        var config = fetchConfig();
        config.body = JSON.stringify({
          updates: updates,
          sections: secoes.map(function (s) { return s.section; }),
          sections_url: window.location.pathname,
        });
        return fetch(window.routes.cart_update_url, config)
          .then(function (r) { return r.json(); })
          .then(function (estado) {
            if (estado.status || estado.errors) {
              var falha = new Error('troca');
              falha.mensagem = estado.description || estado.message || '';
              throw falha;
            }
            secoes.forEach(function (s) {
              var base = document.getElementById(s.id);
              if (!base || !estado.sections || !estado.sections[s.section]) return;
              var alvo = base.querySelector(s.selector) || base;
              alvo.innerHTML = itensEl.getSectionInnerHTML(estado.sections[s.section], s.selector);
            });
            if (temPubSub() && typeof publish === 'function') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: estado });
            }
            // A Shopify pode limitar a quantidade ao estoque sem dar erro: avisa o cliente.
            var linhaNova = (estado.items || []).filter(function (i) { return String(i.variant_id) === String(novaVariante); })[0];
            var recebida = linhaNova ? linhaNova.quantity : 0;
            if (pedido && recebida < pedido) {
              var modelo = window.cartStrings && window.cartStrings.quantityError;
              avisarNaGaveta(modelo ? modelo.replace('[quantity]', recebida) : 'S\u00f3 havia ' + recebida + ' em estoque desta cor.');
            }
            focarLinha(novaVariante);
            return estado;
          });
      })
      .catch(function (e) {
        if (typeof console !== 'undefined') console.error(e);
        avisarNaGaveta((e && e.mensagem) || TEXTO_ERRO_TROCA);
      })
      .finally(function () {
        trocando = false;
        caixa.classList.remove('is-carregando');
        travarLista(false);
      });
  }

  function iniciarTrocaCor() {
    document.addEventListener('click', function (evento) {
      var botao = evento.target.closest ? evento.target.closest('[data-avelore-troca] [data-variante]') : null;
      if (!botao || botao.disabled) return;
      evento.preventDefault();
      var caixa = botao.closest('[data-avelore-troca]');
      trocarCor(caixa, caixa.getAttribute('data-linha'), botao.getAttribute('data-variante'));
    });
  }

  // ---------- produto: barra fixa no celular ----------
  if (!customElements.get('avelore-barra-fixa')) {
    customElements.define('avelore-barra-fixa', class extends HTMLElement {
      connectedCallback() {
        // Vai para o <body>: fora da coluna do produto não herda contexto de empilhamento.
        if (this.parentElement !== document.body) {
          var self0 = this;
          document.querySelectorAll('body > avelore-barra-fixa').forEach(function (el) { if (el !== self0) el.remove(); });
          document.body.appendChild(this);
          return;
        }
        if (this.iniciado) return;
        this.iniciado = true;
        var self = this;
        var acharPrincipal = function () {
          return document.querySelector('product-info .product-form__submit[name="add"]') || document.querySelector('.product-form__submit[name="add"]');
        };
        this.principal = acharPrincipal();
        this.botao = this.querySelector('[data-avelore-comprar]');
        this.preco = this.querySelector('[data-avelore-preco]');
        if (!this.principal || !this.botao) return;
        this.botao.addEventListener('click', function () {
          var principal = acharPrincipal();
          if (principal && !principal.disabled && principal.getAttribute('aria-disabled') !== 'true') principal.click();
        });
        var sincronizar = function () {
          var principal = acharPrincipal();
          var bloqueado = !principal || principal.disabled;
          self.botao.disabled = bloqueado;
          var texto = principal ? principal.querySelector('span') : null;
          self.botao.textContent = bloqueado && texto ? texto.textContent.trim() : TEXTO_ADICIONAR;
          var caixaPreco = document.querySelector('product-info .price');
          if (caixaPreco && self.preco) {
            var item = caixaPreco.classList.contains('price--on-sale')
              ? caixaPreco.querySelector('.price__sale .price-item--sale')
              : caixaPreco.querySelector('.price__regular .price-item--regular');
            if (item && item.textContent.trim()) self.preco.textContent = item.textContent.trim();
          }
        };
        sincronizar();
        var info = document.querySelector('product-info');
        if (info) {
          new MutationObserver(sincronizar).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
        }
        this.acharPrincipal = acharPrincipal;
        var agendado = false;
        var atualizar = function () {
          if (agendado) return;
          agendado = true;
          requestAnimationFrame(function () {
            agendado = false;
            self.atualizarVisibilidade();
          });
        };
        if ('IntersectionObserver' in window) new IntersectionObserver(atualizar).observe(this.principal);
        window.addEventListener('scroll', atualizar, { passive: true });
        this.atualizarVisibilidade();
      }

      // Aparece quando o botão principal já passou para cima da tela; a classe no <body> sobe o botão
      // flutuante do WhatsApp para não cobrir o "Adicionar" da barra (só no celular, via CSS).
      atualizarVisibilidade() {
        var principal = this.acharPrincipal && this.acharPrincipal();
        var mostrar = !!principal && principal.getBoundingClientRect().bottom < 0;
        this.classList.toggle('is-visivel', mostrar);
        document.body.classList.toggle('avelore-barra-visivel', mostrar);
        return mostrar;
      }
    });
  }

  // ---------- produto: seta Voltar ----------
  // Quem veio de outra página da loja volta para ela (mantém a rolagem da coleção);
  // quem chegou direto (anúncio, link externo) segue o link para todos os produtos.
  function iniciarVoltar() {
    document.addEventListener('click', function (evento) {
      var link = evento.target.closest ? evento.target.closest('[data-avelore-voltar]') : null;
      if (!link) return;
      var daLoja = false;
      try {
        daLoja = !!document.referrer && new URL(document.referrer).origin === window.location.origin;
      } catch (e) {
        daLoja = false;
      }
      if (daLoja && window.history.length > 1) {
        evento.preventDefault();
        window.history.back();
      }
    });
  }

  function iniciar() {
    iniciarGaveta();
    iniciarTrocaCor();
    iniciarVoltar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})(typeof window !== 'undefined' ? window : globalThis);
